module.exports = __webpack_public_path__ + "h5/img/billboard-bk.61ac1365.png";